import { Skeleton } from '@/common/components/ui/skeleton';

/** Fallback while the lazily loaded leaflet chunk arrives. Mirrors the map's height. */
export function LocationMapSkeleton() {
  return (
    <div className="h-72 w-full sm:h-96" data-testid="location-map-skeleton">
      <Skeleton className="h-full w-full rounded-lg" />
    </div>
  );
}
